var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"row task",attrs:{"href":"#task-details"},on:{"click":_vm.select}},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(_vm._s(_vm.task.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }